import React, { useEffect, useState } from 'react';
import { useStyles } from './styles';
import { Grid, Typography } from '@material-ui/core';
import { getDocument } from '../../../firebase/tools/getDocument';
import Song from '../../../components/Song';
import { SELECTED_SONG, SELECTED_ALBUM } from './modules/constants';
import { useDispatch, useSelector } from 'react-redux';
import { motion } from 'framer-motion';
import { pageAnimation } from '../../../common/animation';

const Album = (props) => {
  const id = props.match.params.id;
  const classes = useStyles();
  const [songCurrent, setSongCurrent] = useState(null);
  const [render, setRender] = useState(1);
  // render lần đầu và duy nhất 1 lần
  const [albumFirst, setAlbumFirst] = useState(null);
  const dispatch = useDispatch();
  // get album từ store
  const album = useSelector((state) => state.shareStore.selectedAlbum);

  useEffect(() => {
    handleGetAlbum();
  }, []);

  useEffect(() => {
    handleSaveAlbumLocalStorage();
  }, [album]);

  const handleSaveAlbumLocalStorage = () => {
    if (album) {
      localStorage.setItem('zmp3_queue', JSON.stringify(album));
    }
  };

  const handleTwoDispatch = (song, title) => {
    // Dispatch 2 cái khi click mới làm ( để tránh khi người dùng )
    // vừa vào nó load lại mất playlist @@
    // @@ code tới đây chả biết đang làm gì @@ 5h43 AM
    handleDispatchAlbum();
    handleDispatchSong(song, title);
  };

  // fetch album
  const handleGetAlbum = async () => {
    // nếu mà khác id thì dispatch không thì thui giữ nguyên
    const res = await getDocument('albums', id);
    // dữ liệu xài riêng cho component
    setAlbumFirst(res);
  };

  const handleDispatchAlbum = () => {
    dispatch({
      type: SELECTED_ALBUM,
      payload: albumFirst,
    });
    // tăng lên 2 để tạo điều kiện dòng 64
    setRender(render + 1);
  };

  // Khi onClick 1 bài hát thì sẽ dispatch lên cho mấy
  // component khác sử dụng
  // Chặn dispatch nếu click vào bài đang hát (giúp k bị re-render)
  const handleDispatchSong = (song, songTitle) => {
    if (songTitle !== songCurrent) {
      dispatch({
        type: SELECTED_SONG,
        payload: song,
      });
      setSongCurrent(songTitle);
    } else {
      return;
    }
  };

  // sử dụng data của riêng component để render
  const handleRenderForTheFirstTime = () => {
    return (
      <motion.div
        variants={pageAnimation}
        initial="hidden"
        animate="show"
        exit="exit"
      >
        <div className={classes.root}>
          <Grid container spacing={3}>
            <Grid item lg={3} md={4} sm={12}>
              <img
                src={albumFirst.cover}
                alt=""
                width="100%"
                className={classes.img}
              />
              <div className={classes.containerDescription}>
                <Typography className={classes.titleAlbum}>
                  {albumFirst.title}
                </Typography>
              </div>
            </Grid>
            <Grid item lg={9} md={8} sm={12}>
              {albumFirst.songs.map((song, index) => {
                return (
                  <div
                    key={index}
                    onDoubleClick={() => handleTwoDispatch(song, song.title)}
                  >
                    <Song song={song} handleDispatchSong={handleTwoDispatch} />
                  </div>
                );
              })}
            </Grid>
          </Grid>
        </div>
      </motion.div>
    );
  };

  // render những lần tiếp theo theo data từ redux
  const handleRenderNextTime = () => {
    return (
      <div className={classes.root}>
        <Grid container spacing={3}>
          <Grid item lg={3} md={4} sm={12}>
            <img
              src={album.cover}
              alt=""
              width="100%"
              className={classes.img}
            />
            <div className={classes.containerDescription}>
              <Typography className={classes.titleAlbum}>
                {album.title}
              </Typography>
            </div>
          </Grid>
          <Grid item lg={9} md={8} sm={12}>
            {album.songs.map((song, index) => {
              return (
                <div
                  key={index}
                  onDoubleClick={() => handleDispatchSong(song, song.title)}
                >
                  <Song song={song} handleDispatchSong={handleDispatchSong} />
                </div>
              );
            })}
          </Grid>
        </Grid>
      </div>
    );
  };

  const handleRenderSongs = () => {
    // chạy khi mới load component lần đầu
    if (albumFirst && render <= 1) {
      return handleRenderForTheFirstTime();
    }
    // chạy những lần còn lại @@
    else {
      //  lớn hơn 1 vì nếu bé hơn thì album trên
      // redux vẫn còn nó sẽ hiện 1 cái rùi mới có data
      // mới xấu trang nên thêm render > 1
      if (album && render > 1) {
        return handleRenderNextTime();
      }
    }
  };

  return (
    <>
      <div className={`${classes.container} ${classes.bodyScroll}`}>
        {handleRenderSongs()}
        <div style={{ height: '90px' }}></div>
      </div>
    </>
  );
};

export default Album;
